import { memo } from "react";
import {ManualChargeVesselTablePanel} from "./Table/ManualChargeVesselTablePanel";

const ManualChargeVesselContent:React.FC = () => {
        return <div className={`main-comp-wrapper`} style={{width:"60vw", height:"69vh"}}>
                <ManualChargeVesselTablePanel/>
        </div>
}

export default memo(ManualChargeVesselContent);